var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoEdiHover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 4.31243L15.6919 6.67077L13.3335 9.0291L10.9752 6.67077L13.3335 4.31243ZM6.95019 4.71244V8.04577H3.61686V4.71244H6.95019ZM15.2835 13.0458V16.3791H11.9502V13.0458H15.2835ZM6.95019 13.0458V16.3791H3.61686V13.0458H6.95019ZM13.3335 1.9541L8.61686 6.66244L13.3335 11.3791L18.0502 6.66244L13.3335 1.9541ZM8.61686 3.04577H1.9502V9.71243H8.61686V3.04577ZM16.9502 11.3791H10.2835V18.0458H16.9502V11.3791ZM8.61686 11.3791H1.9502V18.0458H8.61686V11.3791Z",
    fill: "#002D62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoEdiHover);
export default __webpack_public_path__ + "static/media/roEdi_hover.7d7ed9b0061fc5ef9acb46ef818658ce.svg";
export { ForwardRef as ReactComponent };